<template>
  <div class="module--chart_by_connector">
    <div class="chart-wrapper" ref="chart" v-if="connectors.length > 0">
      <!-- <div class="loading-dummy" :style="`height:${chart_height}px;`" v-if="!show_chart"></div> -->
      <el-tabs type="border-card" @input="tabChanged">
        <el-tab-pane :label="`${$t('field.cps.connector')} - ${i}`" v-for="i in connectors" :key="i" :lazy="true">
          <div class="daterange-wrap">
            <select @change="rangeChanged" v-model="daterange">
              <option value="today">{{ $t("select.today") }}</option>
              <!-- <option value="7days">{{ $t("select.in7days") }}</option>
              <option value="1months">{{ $t("select.in1months") }}</option> -->
            </select>
          </div>
          <LineChart :ref="`chart_${i}`" :rows="dataset[i]" v-if="show_chart && dataset.hasOwnProperty(i)" :yaxis="getYAxis(dataset[i])"/>
          <div class="no-item-wrap" v-else>
            <div class="message">{{ $t("label.no_data_found") }}</div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- <div class="chart" v-for="i in Object.keys(dataset)" :key="i">
        <LineChart :ref="`chart_${i}`" :rows="dataset[i]" v-if="show_chart"/>
      </div> -->
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/widgets/LineChart";

export default {
  components: {
    LineChart
  },
  async beforeMount() {
    this.fetchData()
  },
  methods: {
    rangeChanged(e) {
      console.log("value: ",e.target.value);
      this.fetchData();
    },
    tabChanged() {
      this.daterange = "today";
      this.fetchData();
    },
    getDateRange() {
      let today = this.$moment();
      let startAt = this.$moment().startOf("day").unix();
      console.log("daterange: ", this.daterange);
      if(this.daterange == "today") {
        startAt = this.$moment().startOf("day").unix();
      }else if(this.daterange == "7days") {
        startAt = this.$moment().add(-7, "days").endOf("day").unix();
      }else if(this.daterange == "1months") {
        startAt = this.$moment().add(-30, "days").endOf("day").unix();
      }

      return [
        startAt,
        this.$moment().add(1, "days").endOf("day").unix()
      ];
    },
    async fetchData() {
      this.show_chart = false;
      this.dataset = {};
      await this.$axios.get(`/cp_connectors`, {
        params: {
          cp_id: this.$route.params.id,
        }
      }).then(res=>{
        this.connectors = res.data.response.dataset.map(c=>c.connector_id);
        return true;
      }).catch(err=>{ return false; });

      await this.$axios.get(`/cp_requests`, {
        params: {
          cp_id: this.$route.params.id,
          connector_required: 1,
          type: "MeterValues",
          cre_dttm: this.getDateRange()
        }
      }).then(res=>{
        res.data.response.dataset.map(row=>{
          if(row.connector_id != null) {
            if(!this.dataset.hasOwnProperty(row.connector_id)) {
              this.dataset[row.connector_id] = [];
            }
            this.dataset[row.connector_id].push(row);
          }
        });
        return true;
      })
      this.$forceUpdate()
      this.show_chart = true;
    },
    getYAxis(rows) {
      let dates = [];
      let items = [];
      rows.map(r=>{
        let json = JSON.parse(r.request_data);
        let meterValue = json.meterValue[0];
        let sampledValue = meterValue["sampledValue"];
        let ts = meterValue.timestamp;
        let date = this.$moment(ts);
        let formatDT = "";
        // after start of date
        console.log("date: ", date.format("YYYY-MM-DD"));
        if(dates.includes(date.format("YYYY-MM-DD"))) {
          formatDT = date.format("HH:mm");
        }else {
          // start of date
          console.log("start of date");
          formatDT = date.format("MM-DD HH:mm");
          dates.push(date.format("YYYY-MM-DD"));
        }
        items.push(formatDT);
      });
      console.log("dates: ", items);
      return items;
    }
  },
  data() {
    return {
      connectors: [],
      dataset: {},
      show_chart: false,
      daterange: "today"
    }
  }
}
</script>

<style lang="scss">
.module--chart_by_connector{
  .chart-wrapper{
    .daterange-wrap{
      display: flex;
      justify-content: flex-end;
    }
    .no-item-wrap{
      min-height: 100px;
      .message{
        font-size: small;
      }
    }
  }
}
</style>